export async function encodeFileToBase64(file) {
  if (!file) return null;
  const fileData = {};
  const base64String = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    // Callback function to handle the file reading operation
    reader.onload = () => {
      const base64String = reader.result.split(",")[1]; // Extract base64 string (remove data URL prefix)
      resolve(base64String); // Resolve with the base64 string
    };

    // Callback function to handle errors during file reading
    reader.onerror = (error) => {
      reject(error); // Reject with the error object
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  });
  let extension = base64String[0];

  if (extension === "/") extension = ".jpg";
  else if (extension === "i") extension = ".png";

  fileData.base64String = base64String;
  fileData.extension = extension;
  return fileData;
}
